function toggleCookieButtonVisibility(pathname: string) {
  const interval = setInterval(() => {
    const cookieBtn = document.querySelector<HTMLElement>(
      ".cky-btn-revisit-wrapper"
    );

    if (cookieBtn) {
      const shouldHide = pathname.includes("dashboard");
      const displayValue = shouldHide ? "none" : "flex";

      cookieBtn.style.setProperty("display", displayValue, "important");

      clearInterval(interval);
    }
  }, 300);
}

export default toggleCookieButtonVisibility;
